import { useLocation } from "react-router-dom";

import { RootState } from "../../redux/store";
import { Paths } from "../../common/constants";
import { Env } from "../../common/constants/env";
import { IMAGES } from "../../common/constants/images";
import { useAppSelector } from "../../hooks/useAppSelector";

const useSidebarHelper = () => {
  const location = useLocation();

  const version = Env.VERSION_NAME || "";

  const { myProfileData } = useAppSelector(
    (state: RootState) => state.myProfile,
  );

  const { cmsLinks } = useAppSelector(
    (state: RootState) => state.globalcontent,
  );
  const { permissions, userType } = myProfileData;
  const hasPermission = (key: string) =>
    permissions?.[key]?.view || userType === "MANUFACTURER_USER";

  const sidebarItems = [
    {
      key: "analytics",
      heading: "Analytics",
      link: Paths.ANALYTICS,
      image: IMAGES.Analytics,
    },
    {
      key: "batches",
      heading: "Batches",
      link: Paths.BATCHES,
      image: IMAGES.Batch,
    },
    {
      key: "strains",
      heading: "Strains",
      link: Paths.STRAINS,
      image: IMAGES.Strains,
    },
    {
      key: "rewards_management",
      heading: "Rewards Management",
      link: Paths.REWARDS_MANAGEMENT,
      image: IMAGES.Reward,
    },
    {
      key: "qr_code",
      heading: "Databis QR Codes",
      link: Paths.QR_CODE_PURCHASING,
      image: IMAGES.Qr,
    },
    {
      key: "announcements",
      heading: "Announcements",
      link: Paths.ANNOUNCEMENTS,
      image: IMAGES.Announcements,
    },
    {
      key: "support",
      heading: "Support",
      link: Paths.SUPPORT_PAGE,
      image: IMAGES.Support,
    },
  ];

  return {
    version,
    userType,
    location,
    cmsLinks,
    sidebarItems,

    hasPermission,
  };
};

export default useSidebarHelper;
